export const BASE = window.location.origin;

export const BASE_URL = `${BASE}/api/`;
export const BASE_IMG_URL = `${BASE}/storage`;
export const AUTH_TOKEN = "auth/token";
export const AUTH_PROFILE = "auth/profile";
export const CONSTANTS = "constants";

export const PRODUCT = "product";
export const EQUIPMENT = "equipment";
export const CENTER = "center";
export const RESIDENT = "resident";
export const POST = "post";
export const EMPLOYEE = "employee";
export const ACCOUNTING = "accounting";
export const TAG = "tag";
export const USER = "user";
export const DOCUMENT = "document";
export const EXPORT = "export";
export const REPORT_DATE = "reportDate";
export const REPORT = "report";
export const ORDER = "order";
